import { PROCCESS_BOOKING_V2, PROCCESS_BOOKING_V2_SUCCESS, PROCCESS_BOOKING_V2_ERROR, PROCCESS_BOOKING_V2_EMPTY } from '../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ProccessBookingV2 = (state = initialState, action) => {
  switch (action.type) {
    case PROCCESS_BOOKING_V2:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case PROCCESS_BOOKING_V2_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case PROCCESS_BOOKING_V2_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: null,
      };
      break;

    case PROCCESS_BOOKING_V2_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ProccessBookingV2;
